module.exports = __webpack_public_path__ + "img/Stemness-ASHN_GSE227469.203c6a73.png";